import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-hot-toast';
import useGroup from '../../context/group.context.jsx';
import groupServices from '../services/groupServices';

const PENDING_KEY = 'pendingInviteCode';

/**
 * Mounted once inside GroupProvider (see App.jsx's ProtectedShell). Picks up
 * an invite code left in localStorage by pages/joinByCode.jsx — whether the
 * visitor got there already signed in, or had to register/log in first — and
 * joins the group as soon as this user's groups are loaded.
 */
export default function PendingInviteConsumer() {
    const { t } = useTranslation('common');
    const { groupsLoaded, refreshGroups, setActiveGroup } = useGroup();
    const consumedRef = useRef(false);

    useEffect(() => {
        if (!groupsLoaded || consumedRef.current) return;
        const code = localStorage.getItem(PENDING_KEY);
        if (!code) return;
        consumedRef.current = true;
        localStorage.removeItem(PENDING_KEY);

        (async () => {
            try {
                const { group } = await groupServices.joinByCode(code);
                await refreshGroups();
                setActiveGroup(group._id);
                toast.success(t('joinedViaInvite', { name: group.name }));
            } catch (error) {
                toast.error(error.response?.data?.error || t('joinFailed'));
            }
        })();
    }, [groupsLoaded, refreshGroups, setActiveGroup, t]);

    return null;
}
